/**
 * Creates the company receipt section for the main receipt
 * @param {Object} order - The order with company information
 * @param {Function} t - Translation function
 * @returns {String} HTML content for company receipt section
 */
const createCompanyReceipt = (order, t) => {
  
  
  if (!order) return '';
  
  // Only display company section if it's a company order with company name or tax number
  // Works for both cash and card orders by checking for payment method and company info
  if (order.customer_type !== 'company' || 
      (!order.company_name && !order.company_tax_number)) {
    
    return '';
  }
  
  
  return `
    <div style="border: 1px dashed #000; margin: 3mm 0; padding: 3mm;">
      <div style="text-align: center; font-weight: bold; margin-bottom: 2mm; font-size: 110%;">
        ${t('cashier.payment.companyCustomer')}
      </div>
      
      ${order.company_name ? `
      <div style="margin-bottom: 1mm;">
        <span style="font-weight: bold;">${t('cashier.payment.companyName')}:</span>
        <span>${order.company_name}</span>
      </div>
      ` : ''}
      
      ${order.company_tax_number ? `
      <div>
        <span style="font-weight: bold;">${t('cashier.payment.taxNumber')}:</span>
        <span>${order.company_tax_number}</span>
      </div>
      ` : ''}
    </div>
  `;
};

export default createCompanyReceipt;
